import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import App from "./App";
import Layout from "./components/layout";
import AppLanding from "./pages/applanding";
import QuantingoApps from "./pages/quantingoapps";
import { apps } from "./apps";
import { useMetadata } from "./seo";
import Contact from "./pages/contact";
import HowWeWork from "./pages/how-we-work";
import Services from "./pages/services";
import Engineering from "./pages/engineering";
import Partners from "./pages/partners";
export const legacyRoutes = {
  about: "about",
  blockchain: "software-architecture",
  rtscs: "high-reliability",
  milap: "high-reliability",
  dtscience: "ai-ml",
  sdlc: "software-architecture",
};
function Home() {
  const { hash } = useLocation();
  useMetadata("Quantingo | Software Engineering & Systems Architecture", "/");
  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
  }, [hash]);
  return <App />;
}
function NotFound() {
  useMetadata("Page not found | Quantingo", null);
  return (
    <Layout>
      <div className="container support-page">
        <p className="eyebrow">404 / Page not found</p>
        <h1>Let’s get you back on track.</h1>
        <p>The page you’re looking for isn’t available.</p>
        <a className="button" href="/">
          Explore Quantingo
        </a>
      </div>
    </Layout>
  );
}
export default function SiteRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/how-we-work" element={<HowWeWork />} />
      <Route path="/services" element={<Services />} />
      <Route path="/engineering" element={<Engineering />} />
      <Route path="/partners" element={<Partners />} />
      {Object.entries(legacyRoutes).map(([path, section]) => (
        <Route
          key={path}
          path={`/${path}`}
          element={<Navigate replace to={`/#${section}`} />}
        />
      ))}
      <Route path="/quantingoapps" element={<QuantingoApps />} />
      {apps.map(([path, name, id]) => (
        <Route
          key={path}
          path={`/${path}/*`}
          element={<AppLanding appName={name} packageId={id} path={path} />}
        />
      ))}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
